import { lazyModule } from '../../lib/lazyModule'

// The first-visit note (outside the U.S. / no location) is its own chunk, fetched only for a visit that has one:
// main.tsx waits for it before the first render, so it never pops in late.
const firstVisitNote = lazyModule(() => import('../../components/FirstVisitNote'))
export const loadFirstVisitNote = firstVisitNote.load
export const useFirstVisitNote = firstVisitNote.use
